import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './context/AuthContext';
import { AppThemeProvider } from './context/AppThemeContext';
import './index.css';

ReactDOM.render(
  <BrowserRouter>
    <AppThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </AppThemeProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);
